module.exports = __webpack_public_path__ + "static/media/fa-solid-900.be7173c2.svg";